import React, { useState, useContext, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import toast from 'react-hot-toast';
import Select from 'react-select';
import Button from '../Button';
import { SEARCH_TYPES } from '../../util/customersUtil';
import useMutateAnalytics from '../../util/mutate.Analytics';
import analyticsKeys from '../../util/UsageStatLinks';
import { UserContext } from '../../context/UserContext';
import colors from '../../styles/colors';

const Form = styled.form`
  width: clamp(250px, 75vw, 300px);
  padding: 20px 15px;
`;

const TooltipStyles = createGlobalStyle`
.__react_component_tooltip{
      display: inline-block !important;
      max-width: 300px;
    };
    .css-12jo7m5{
      font-size:13px !important;
    };
    .css-1pahdxg-control{
      border-color: ${colors.grey3} !important;
      box-shadow: none !important;
      min-height: 40px;
    }
    .css-yk16xz-control{
      min-height: 40px !important;
    };
`;

const MessageDetails = styled.div`
  display: flex;
  font-size: 1.2rem;
  color: ${colors.grey3};
  padding: 0 5px;
  margin: 10px 0;
`;

const customStyles = {
  option: (provided) => ({
    ...provided,
    fontSize: '13px',
  }),
};

export default function TagsFilterContacts({
  setSearchQuery,
  searchQuery,
  close,
}) {
  const { user } = useContext(UserContext);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState(() => {
    return searchQuery?.tags?.map((tag) => ({ label: tag, value: tag })) || [];
  });
  const mutateAnalytics = useMutateAnalytics();
  useEffect(() => {
    if (user?.organization?.tags) {
      const tagsData = user?.organization?.tags.map((tag) => {
        return {
          label: tag,
          value: tag,
        };
      });
      setTags(tagsData);
    }
  }, [user]);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        if (selectedTags.length) {
          setSearchQuery({
            type: SEARCH_TYPES.TagsFiltered,
            tags: selectedTags.map((item) => item.value),
          });
          const mutateAnalyticsVariables = {
            link: analyticsKeys.CONTACTS_FILTERED_BY_TAGS,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          close();
        } else {
          toast.error('Please select a tag to filter ');
        }
      }}
    >
      <div style={{ marginTop: '0px' }}>
        <MessageDetails>Tags</MessageDetails>{' '}
        <Select
          onChange={(updatedTags) => setSelectedTags(updatedTags || [])}
          options={tags}
          isClearable={false}
          isMulti
          value={selectedTags}
          styles={customStyles}
        />
      </div>

      <Button
        margin="40px 0px 0px 0px"
        text="Filter Contacts"
        type="submit"
        width="100%"
      />
      <TooltipStyles />
    </Form>
  );
}
